module.exports = __webpack_public_path__ + "static/img/6.a2624624.jpg";